import React, { useState, useEffect } from "react";
import axios from "axios";
import { message, Modal } from "antd";
import "../../../Styles/SellerStylings/ProductList.css";
import { EditOutlined, FormOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { DeleteOutlined } from "@ant-design/icons";
import SummaryApi from "../../../common/index";

function ProductList({ token,setActiveTab, setEditProduct }) {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
 
  const [filters, setFilters] = useState({
    category: "",
    stock: "",
    status: "",
  });
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  const BASE_URL = process.env.REACT_APP_BACKEND_URL;
  const defaultImage = "/images/default_product.jpg";

  const fetchProducts = async () => {
    try {
      const params = {};
      if (filters.category) params.category = filters.category;
      if (searchTerm) params.search = searchTerm;
      if (filters.stock) params.stock = filters.stock;
      const res = await axios.get(SummaryApi.getProducts.url, {
        headers: { Authorization: `Bearer ${token}` },
        params,
      });

      setProducts(res.data.success ? res.data.products || [] : []);
    } catch (err) {
      console.error("Error fetching products:", err);
      message.error("Failed to load products");
    }
  };

  const fetchCategories = async () => {
    try {
      const res = await axios.get(SummaryApi.getCategories.url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.data.success) {
        setCategories(res.data.categories || []);
      }
    } catch (err) {
      console.error("Error fetching categories:", err);
      message.error("Failed to load categories");
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${SummaryApi.deleteProduct.url}/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      message.success("Product deleted Successfully");
      fetchProducts();
    } catch (err) {
      console.error("Error deleting product:", err.response?.data || err.message);
      message.error("Failed to delete product");
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    fetchProducts();
  }, [filters, searchTerm]);

  // ✅ Open image preview
  const handleImageClick = (imgSrc) => {
    setPreviewImage(imgSrc || defaultImage);
    setPreviewVisible(true);
  };
  
const handleEdit = (product) => {
  setEditProduct(product);      // store selected product
  setActiveTab("uploadProduct"); // switch tab to upload form
};

  return (
    <div>
      <h2>Products</h2>

      <div className="filter-panel">
        <select
          value={filters.category}
          onChange={(e) => setFilters({ ...filters, category: e.target.value })}
        >
          <option value="">All Categories</option>
          {categories.map((cat) => (
            <option key={cat.id} value={cat.name}>
              {cat.name}
            </option>
          ))}
        </select>

        <div className="search-bar">
          <input
            type="text"
            placeholder="Search by product name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <select
          value={filters.stock}
          onChange={(e) => setFilters({ ...filters, stock: e.target.value })}
        >
          <option value="">All Stock</option>
          <option value="in">In Stock</option>
          <option value="out">Out of Stock</option>
        </select>
      </div>

      {/* PRODUCT GRID */}
      <div className="product-grid">
        {products.map((p) => {
        let imageSrc = defaultImage;
try {
  const imagesArray = Array.isArray(p.images)
    ? p.images
    : JSON.parse(p.images || "[]");

  if (imagesArray.length > 0 && imagesArray[0]) {
    const cleanPath = imagesArray[0].startsWith("/")
      ? imagesArray[0]
      : `/${imagesArray[0]}`;
    imageSrc = `${BASE_URL}${cleanPath}`;
  }
} catch (err) {
  console.warn("Error parsing product images:", err);
}

                  console.log("Products in frontend:", products);

          return (
            <div className="product-card" key={p.id}>
              <div
                className="image-wrapper"
                onClick={() => handleImageClick(imageSrc)}
              >
                <img
                  src={imageSrc}
                  alt={p.name}
                  className="product-image" 
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = defaultImage;
                  }}
                />
              </div>
              <div className="product-info">
                <h3 className="product-name">{p.name}</h3>
                <p className="product-category">{p.category_name}</p>
                <div className="price-row">
                  <span className="selling-price">₹{p.selling_price}</span>
                  <span className="actual-price">₹{p.actual_price}</span>
                </div>

                <div className="stock-delivery">
                  <span className="product-stock">Stock: {p.stock}</span>
                  <span className="product-delivery">
                    {p.deliveryOption === "store_pickup"
                      ? "Store Pickup"
                      : "Home Delivery"}
                  </span>
                </div>
                <div className="action-icons">
<FormOutlined style={{ fontSize: 25, color: "#1129ce"}}
  onClick={() => handleEdit(p)}
/>
<DeleteOutlined
                  style={{fontSize:"25px" ,color:"#ee152d"}}
                  onClick={() => handleDelete(p.id)}
                />
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* ✅ Image Preview Modal */}
      <Modal
        open={previewVisible}
        footer={null}
        onCancel={() => setPreviewVisible(false)}
        centered
      >
        <img
          alt="Product Preview"
          style={{ width: "100%", borderRadius: "8px" }}
          src={previewImage || defaultImage}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = defaultImage;
          }}
        />
      </Modal>
    </div>
  );
}

export default ProductList;
